import { GetCycleItemInfoResponse } from '../api-services/get-cycle-item-info.service';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { PRICE_PATTERN_LIST } from '../kymw1200.constants';

/**
 * サイクル設定画面の企画回別情報クラス
 *
 * @export CatalogInfo
 * @class CatalogInfo
 */
export class CatalogInfo {
  /** 企画確定ステータス */
  public static readonly STATUS_PLAN_FIXED = '2';
  /** サイクル確定ステータス */
  public static readonly STATUS_CYCLE_FIXED = '1';
  /** 編集可能ステータス */
  public static readonly STATUS_EDITABLE = '0';
  /** 価格パターン 特価 */
  public static readonly SPECAIL_PRICE_PATTERN_LIST = ['1', '2', '3'];
  /** フラグ値 TRUE */
  public static readonly FLAG_TRUE = '1';
  /** フラグ値 FALSE */
  public static readonly FLAG_FASE = '0';

  orderCode: string;
  catalogId: string;
  status: string;
  pricePattern: string;
  featureCode: string;
  selectedOthers: boolean;
  komaPromotion: string;
  dispValue1: number;
  dispValue2: number;
  delivStartDate: string;
  catalogMemo: string;
  dispPatternAndMemo: string;
  copyCatalogMemoFlg: boolean;

  constructor(
    data: GetCycleItemInfoResponse['CycleItemInfoList'][number]['CatalogInfoList'][number]
  ) {
    this.orderCode = data.OrderCode;
    this.catalogId = data.CatalogId;
    this.status = data.Status;
    this.pricePattern = data.PricePattern;
    this.featureCode = data.FeatureCode;
    this.selectedOthers =
      CatalogInfo.FLAG_TRUE === data.SelectedOthers ? true : false;
    this.komaPromotion = data.KomaPromotion;
    this.dispValue1 = data.DispValue1;
    this.dispValue2 = data.DispValue2;
    this.delivStartDate = data.DelivStartDate;
    this.catalogMemo = data.CatalogMemo;
    this.dispPatternAndMemo = this.getPricePatternShape(data.PricePattern) + this.catalogMemo;
    this.copyCatalogMemoFlg = false;
  }

  /** 編集可否判定 (企画未確定) */
  get enableEdit() {
    return CatalogInfo.STATUS_EDITABLE === this.status;
  }

  /** 特価判定 */
  get isSpecialPrice() {
    return CatalogInfo.SPECAIL_PRICE_PATTERN_LIST.includes(this.pricePattern);
  }

  /** 表示値 (区分１) */
  get dispValueTypeOne() {
    return this.pricePattern;
  }

  /** 表示値 */
  get dispValue() {
    if (!this.dispValue1 && !this.dispValue2) return '';
    return (
      PlessViewUtilsSub.editPriceComma(this.dispValue1 ?? 0, true) +
      '/' +
      PlessViewUtilsSub.editPriceComma(this.dispValue2 ?? 0, true)
    );
  }

    /**
   * 価格パターン 記号取得
   *
   * @memberof KYMW1200Component
   */
  public getPricePatternShape(val: string) {
    const el = PRICE_PATTERN_LIST.find(_ => val === _.Code);
    if (el) return el.plain;
    return PRICE_PATTERN_LIST[0].plain;
  }

}
